function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "archive-down-svgrepo-com",
  transform: "translate(-0.5 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32417",
  "data-name": "Path 32417",
  d: "M37.122,7V18.867c0,7.459,0,11.188-2.317,13.5s-6.046,2.317-13.5,2.317H19.322c-7.459,0-11.188,0-13.5-2.317S3.5,26.325,3.5,18.867V7",
  transform: "translate(1.467 3.911)",
  fill: "none",
  stroke: "#8b8c8e",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32418",
  "data-name": "Path 32418",
  d: "M2,6.956c0-1.865,0-2.8.579-3.376S4.091,3,5.956,3H37.6c1.865,0,2.8,0,3.376.579s.579,1.512.579,3.376,0,2.8-.579,3.376-1.512.579-3.376.579H5.956c-1.865,0-2.8,0-3.376-.579S2,8.82,2,6.956Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#8b8c8e",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32419",
  "data-name": "Path 32419",
  d: "M14.933,7V24.8m0,0,5.933-6.592M14.933,24.8,9,18.207",
  transform: "translate(6.844 3.911)",
  fill: "none",
  stroke: "#8b8c8e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.555,
    height: 38.6,
    viewBox: "0 0 42.555 38.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.d62d88d1.svg";
export { ForwardRef as ReactComponent };